// eslint-disable-next-line no-implicit-globals
var apiHelper = require('../utils/api_helper');

// eslint-disable-next-line no-undef,max-statements
module.exports = (function() {
  'use strict';

  function KentekenElement(container) {
    this.container = container;
    this.controls = {
      textbox: this.container.querySelector('.js-kenteken-element__input'),
      textboxContainer: this.container.querySelector('.js-kenteken-element__control_container'),
      merkInput: this.container.querySelector('.js-kenteken-element__merk'),
      modelInput: this.container.querySelector('.js-kenteken-element__model'),
      typeInput: this.container.querySelector('.js-kenteken-element__type'),
      infoElement: this.container.querySelector('.js-kenteken-element__info'),
      validationElement: this.container.querySelector('.js-kenteken-element__validation')
    };
    this.properties = {
    };

    if (this.container.dataset.hasOwnProperty('kentValidVehicletypes')) {
      this.properties.validVehicleTypes =
        this.container.dataset.kentValidVehicletypes.toUpperCase().split('|');
    }
    this.state = {
      currentKenteken: ''
    };

    this.init();
    this.bindEvents();
  }

  KentekenElement.prototype.init = function() {
    // Initialize method
    var formButtonSelector = this.container.dataset.kentFormbutton;

    if (formButtonSelector) {
      this.controls.formbutton = document.querySelector(formButtonSelector);
    } else {
      const form = this.container.closest('.ipo-mdc-form');

      if (form) {
        this.controls.formbutton = form.querySelector('.postbutton');
      }
    }
  };

  // eslint-disable-next-line max-statements
  KentekenElement.prototype.validateAndFormatKenteken = function(stopIfLengthIsNotCorrect) {
    const kentekenValue = this.controls.textbox.value.toUpperCase();

    if (kentekenValue === this.state.currentKenteken ||
        stopIfLengthIsNotCorrect && kentekenValue && kentekenValue.replaceAll('-', '').length < 6) {
      return;
    }

    this.clearAdditionalFields();
    let validationResult = this.validateKenteken(kentekenValue);

    if (validationResult.kentekenValid) {
      this.controls.textbox.value = validationResult.kentekenOpgemaakt;
      this.state.currentKenteken = validationResult.kentekenOpgemaakt;
      this.retrieveCarInfo(kentekenValue);
    } else {
      this.state.currentKenteken = kentekenValue;

      if (this.controls.textbox.value.length > 0) {
        this.setValidation('false');
      }
    }
  };

  KentekenElement.prototype.validateKenteken = function(kenteken) {
    let kentekenValid = false,
     kentekenOpgemaakt = kenteken,
     kentekenValue = kenteken;

     kentekenValue = kentekenValue.toUpperCase().replace(/-/g, '');
    const arrRegEx = [
      // XX9999
      '^([A-Z]{2})([0-9]{2})([0-9]{2})$',
      // 9999XX
      '^([0-9]{2})([0-9]{2})([A-Z]{2})$',
      // 99XX99
      '^([0-9]{2})([A-Z]{2})([0-9]{2})$',
      // XX99XX
      '^([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{2})$',
      // XXXX99
      '^([BDFGHJKLMNPRSTVWXYZ]{2})([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{2})$',
      // 99XXXX
      '^([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{2})([BDFGHJKLMNPRSTVWXYZ]{2})$',
      // 99XXX9
      '^([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{3})([0-9]{1})$',
      // 9XXX99
      '^([0-9]{1})([BDFGHJKLMNPRSTVWXYZ]{3})([0-9]{2})$',
      // XX999X
      '^([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{3})([BDFGHJKLMNPRSTVWXYZ]{1})$',
      // X999XX
      '^([BDFGHJKLMNPRSTVWXYZ]{1})([0-9]{3})([BDFGHJKLMNPRSTVWXYZ]{2})$',
      // XXX99X
      '^((?!PVV|VVD|SGP)[BDFGHJKLMNPRSTVWXYZ]{3})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{1})$',
      // X99XXX
      '^([BDFGHJKLMNPRSTVWXYZ]{1})([0-9]{2})([BDFGHJKLMNPRSTVWXYZ]{3})$',
      // 9XX999
      '^([0-9]{1})([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{3})$',
      // 999XX9
      '^([0-9]{3})([BDFGHJKLMNPRSTVWXYZ]{2})([0-9]{1})$'
    ];

    if (kentekenValue.length === 6) {
      let index = 0;

      arrRegEx.some((regEx, regindex) => {
        const reg = new RegExp(regEx),
         res = reg.test(kentekenValue);

         // match on regex pattern
        if (res === true) {
          index = regindex;
          kentekenValid = true;
          return true;
        }

        return false;
      });

      if (kentekenValid) {
        const reg = new RegExp(arrRegEx[index]);

        kentekenOpgemaakt = kentekenValue.replace(reg, '$1-$2-$3');
      }
    }

    return {
      kentekenValid,
      kentekenOpgemaakt
    };
  };

  KentekenElement.prototype.retrieveCarInfo = function(kentekenValue) {
    const self = this;

    if (!kentekenValue) {
      return;
    }

    this.showLoader(true);
    apiHelper.post('/apiproxy/VoertuigInformatie/OphalenVoertuiginformatieOpKenteken',
      {
        vehicle: {
          licenseplate: kentekenValue.replaceAll('-', ''),
          additionalinfoatl: true
        }
      },
      // eslint-disable-next-line max-statements
      function(data) {
        self.showLoader(false);
        if (data && data.vehicleinformation) {
          if (data.vehicleinformation.commoninfo && self.properties.validVehicleTypes &&
              !self.properties.validVehicleTypes
                .includes(data.vehicleinformation.commoninfo.vehicletype)) {
            // Object is not a valid vehicle type
            self.setValidation('unsupported-vehicletype');
            return;
          }
          if (data.vehicleinformation.makeinfo) {
            let result = data.vehicleinformation.makeinfo.make;

            self.controls.merkInput.value = data.vehicleinformation.makeinfo.make;

            if (data.vehicleinformation.makeinfo.model) {
              result = result + ' ' + data.vehicleinformation.makeinfo.model;
              self.controls.modelInput.value = data.vehicleinformation.makeinfo.model;
            }
            if (data.vehicleinformation.makeinfo.type) {
              result = result + ' ' + data.vehicleinformation.makeinfo.type;
              self.controls.typeInput.value = data.vehicleinformation.makeinfo.type;
            }
            if (data.vehicleinformation.histinfo &&
              data.vehicleinformation.histinfo.datefirstadmission) {
              let date = new Date(data.vehicleinformation.histinfo.datefirstadmission);

              result = result + ' (' + date.getFullYear() + ')';
            }

            self.controls.infoElement.innerHTML = result;
            self.setValidation('true');
          }
        }
      },
      function(err) {
        self.setValidation('apierror');
        self.showLoader(false);
      }
    );
  };

  KentekenElement.prototype.showLoader = function(mustShow) {
    if (mustShow) {
      this.container.classList.add('kenteken-element--loading');
      if (this.controls.formbutton) {
        this.controls.formbutton.classList.add('button--disabled');
        this.controls.formbutton.disabled = true;
      }
    } else {
      this.container.classList.remove('kenteken-element--loading');
      if (this.controls.formbutton) {
        this.controls.formbutton.classList.remove('button--disabled');
        this.controls.formbutton.disabled = false;
      }
    }
  };

  KentekenElement.prototype.setValidation = function(value) {
    this.controls.textbox.dataset.kentekenvalid = value;

    if (value !== '') {
      const event = new Event('kenteken');

      this.controls.textbox.dispatchEvent(event);
    }
  };

  KentekenElement.prototype.clearAdditionalFields = function() {
    this.setValidation('');
    this.controls.merkInput.value = '';
    this.controls.modelInput.value = '';
    this.controls.typeInput.value = '';
    this.controls.infoElement.innerHTML = '';
    this.container.classList.remove('parsley-error');
    this.controls.textboxContainer.classList.remove('mdc-text-field--invalid');
    this.controls.validationElement.innerHTML = '';
  };

  KentekenElement.prototype.bindEvents = function() {
    var self = this;

    if (this.controls.textbox) {
      this.controls.textbox.addEventListener('blur', function(event) {
        self.validateAndFormatKenteken(false);
      });

      this.controls.textbox.addEventListener('keyup', function(event) {
        self.validateAndFormatKenteken(true);
      });

      this.controls.textbox.addEventListener('kenteken:clear', function(event) {
        self.controls.textbox.value = '';
        self.state.currentKenteken = '';
        self.clearAdditionalFields();
      });
    }
  };

  return {
    initialize: function() {
      var controls = document.querySelectorAll('.js-kenteken-element');

      if (controls && controls.length > 0) {
        controls.forEach(element => {
          // eslint-disable-next-line no-new
          new KentekenElement(element);
        });
      }
    }
  };
})();

